<mat-tab-group>
    <mat-tab label="{{ 'settings.user_settings.title' | translate }}">
        <user-settings
            [settings]="userSettings$ | async"
            (saved)="saveUserSettings($event)"
        ></user-settings>
    </mat-tab>
    <mat-tab label="{{ 'settings.report_email_settings.title' | translate }}">
        <report-email-settings
            [settings]="userSettings$ | async"
            (saved)="saveUserSettings($event)"
        ></report-email-settings>
    </mat-tab>
</mat-tab-group>



// WEBPACK FOOTER //
// /app/src/app/settings/pages/settings/settings.component.html